export default __webpack_public_path__ + "static/media/img_area_100.99151c86.svg";